import { useState } from 'react';
import {
    Box,
    Center,
    FormControl,
    FormLabel,
    HStack,
    Input,
    Text,
    Textarea,
    VStack,
    useColorModeValue,
} from '@chakra-ui/react';
import Button from 'components/ui/Button';
import CustomDrawer from 'components/ui/Drawer';

export default function DrawerPreview() {
    const [isOpen1, setIsOpen1] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen3, setIsOpen3] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        description: '',
    });

    const bg = useColorModeValue('gray.50', 'gray.900');

    const handleSave = () => {
        setIsSaving(true);
        setTimeout(() => {
            console.log('Datos guardados:', formData);
            setIsSaving(false);
            setIsOpen1(false);
        }, 1500);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <Center minH="100vh" bg={bg} p="40px">
            <VStack spacing="48px" w="100%" maxW="700px">
                <Text fontSize="xl" fontWeight="700">
                    Drawer — Preview
                </Text>

                <Box w="100%" h="1px" bg="gray.200" />

                {/* Drawer 1: Con footer de guardar/cancelar */}
                <VStack spacing="16px" align="flex-start" w="100%">
                    <Text fontSize="sm" fontWeight="700" color="gray.600">
                        Drawer con formulario (tamaño: md)
                    </Text>
                    <Button variant="brand" onClick={() => setIsOpen1(true)}>
                        Abrir Drawer
                    </Button>

                    <CustomDrawer
                        isOpen={isOpen1}
                        onClose={() => setIsOpen1(false)}
                        title="Editar Información"
                        size="lg"
                        placement="right"
                        onSave={handleSave}
                        isSaving={isSaving}
                        saveButtonText="Guardar"
                        cancelButtonText="Cancelar"
                        
                        borderRadius="10px"
                        borderRadiusSides="left"
                        
                        width="700px"
                        layout='form'
                    >
                        <FormControl>
                            <FormLabel fontSize="sm" fontWeight="600">
                                Nombre
                            </FormLabel>
                            <Input
                                placeholder="Ingresa tu nombre"
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                size="sm"
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel fontSize="sm" fontWeight="600">
                                Email
                            </FormLabel>
                            <Input
                                placeholder="Ingresa tu email"
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                size="sm"
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel fontSize="sm" fontWeight="600">
                                Descripción
                            </FormLabel>
                            <Textarea
                                placeholder="Ingresa una descripción"
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                size="sm"
                                minH="120px"
                            />
                        </FormControl>
                    </CustomDrawer>
                </VStack>

                <Box w="100%" h="1px" bg="gray.200" />

                {/* Drawer 2: Posición Left, tamaño small */}
                <VStack spacing="16px" align="flex-start" w="100%">
                    <Text fontSize="sm" fontWeight="700" color="gray.600">
                        Drawer desde la izquierda (tamaño: sm)
                    </Text>
                    <Button variant="brand" onClick={() => setIsOpen2(true)}>
                        Abrir Drawer Left
                    </Button>

                    <CustomDrawer
                        isOpen={isOpen2}
                        onClose={() => setIsOpen2(false)}
                        title="Opciones de Menú"
                        size="sm"
                        placement="left"
                    >
                        <VStack spacing="12px" w="100%">
                            <Button w="full" variant="ghost" justifyContent="flex-start">
                                Opción 1
                            </Button>
                            <Button w="full" variant="ghost" justifyContent="flex-start">
                                Opción 2
                            </Button>
                            <Button w="full" variant="ghost" justifyContent="flex-start">
                                Opción 3
                            </Button>
                            <Button w="full" variant="ghost" justifyContent="flex-start">
                                Eliminar
                            </Button>
                        </VStack>
                    </CustomDrawer>
                </VStack>

                <Box w="100%" h="1px" bg="gray.200" />

                {/* Drawer 3: Sin close button, custom footer */}
                <VStack spacing="16px" align="flex-start" w="100%">
                    <Text fontSize="sm" fontWeight="700" color="gray.600">
                        Drawer con footer personalizado (tamaño: lg)
                    </Text>
                    <Button variant="brand" onClick={() => setIsOpen3(true)}>
                        Abrir Drawer Personalizado
                    </Button>

                    <CustomDrawer
                        isOpen={isOpen3}
                        onClose={() => setIsOpen3(false)}
                        title="Detalles del Paciente"
                        size="lg"
                        placement="right"
                        showCloseButton={true}
                        footer={
                            <HStack spacing="12px" w="full">
                                <Button flex="1" variant="ghost" onClick={() => setIsOpen3(false)}>
                                    Cerrar
                                </Button>
                                <Button flex="1" variant="brand">
                                    Ir al Perfil
                                </Button>
                            </HStack>
                        }
                    >
                        <Box
                            p="16px"
                            bg="blue.50"
                            borderRadius="lg"
                            borderLeft="4px"
                            borderColor="blue.500"
                        >
                            <Text fontSize="sm" fontWeight="600" mb="8px">
                                Información del Paciente
                            </Text>
                            <Text fontSize="sm" color="gray.600">
                                Este es un drawer con footer personalizado. Puedes agregar cualquier contenido aquí.
                            </Text>
                        </Box>

                        <VStack spacing="8px" align="stretch">
                            <Text fontSize="sm" fontWeight="600">
                                📋 Datos Principales:
                            </Text>
                            <Text fontSize="sm" color="gray.600">
                                • Nombre: Juan Pérez
                            </Text>
                            <Text fontSize="sm" color="gray.600">
                                • Edad: 35 años
                            </Text>
                            <Text fontSize="sm" color="gray.600">
                                • Estado: Activo
                            </Text>
                        </VStack>
                    </CustomDrawer>
                </VStack>

                <Box w="100%" h="1px" bg="gray.200" />

                <VStack spacing="4px" align="flex-start" w="100%">
                    <Text fontSize="sm" fontWeight="600" color="gray.600">
                        Props disponibles:
                    </Text>
                    <Text fontSize="xs" color="gray.500">
                        • size: xs, sm, md, lg, xl, full
                    </Text>
                    <Text fontSize="xs" color="gray.500">
                        • placement: left, right, top, bottom
                    </Text>
                    <Text fontSize="xs" color="gray.500">
                        • onSave: Callback para guardar
                    </Text>
                    <Text fontSize="xs" color="gray.500">
                        • isSaving: Estado de carga
                    </Text>
                    <Text fontSize="xs" color="gray.500">
                        • footer: Footer personalizado
                    </Text>
                </VStack>
            </VStack>
        </Center>
    );
}
